module.exports = __webpack_public_path__ + "media/images/flags/4x3/lbn-675dd9cbea7927c3f6af8ac4bddfcc45.svg";